import { render, staticRenderFns } from "./DraftAlerts.vue?vue&type=template&id=77a38406&scoped=true&"
import script from "./DraftAlerts.vue?vue&type=script&lang=js&"
export * from "./DraftAlerts.vue?vue&type=script&lang=js&"
import style0 from "./DraftAlerts.vue?vue&type=style&index=0&id=77a38406&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a38406",
  null
  
)

export default component.exports